
document.addEventListener('DOMContentLoaded',function (){

    gsap.registerPlugin(ScrollTrigger);
        let tl = gsap.timeline()
   tl.from('a.logolink',{
     y:-30,
     opacity:0,
     duration:0.5,
    

});
 tl.from('.thb-full-menu li',{
     y:-20,
     opacity:0,
     duration:0.5,
     stagger:0.1,

});
 gsap.from('.thb-header-right .thb-secondary-area-item',{
     y:-30,
     opacity:0,
     duration:0.5,
    

});
 gsap.from('.layered-images-with-text__image',{
     x:300,
     opacity:0,
    
     duration:1,
     scrollTrigger :{
        trigger:".layered-images-with-text__image",
        scroller :"body",
        start:"top 60%",
     }
    

});
 gsap.from('.layered-images-with-text__content--inner > *',{
     y:30,
     opacity:0,    
     duration:1,
     stagger:0.5,
     scrollTrigger :{
        trigger:".layered-images-with-text__content--inner",
        scroller :"body",
        start:"top 60%"
     }
    

});
 gsap.from('.featured-collection .section-header--content> *',{
     y:30,
     opacity:0,    
     duration:0.8,
     stagger:0.5,
     scrollTrigger :{
        trigger:".featured-collection",
        scroller :"body",
        start:"top 50%"
     }
});
 gsap.from('.collection-tabs .section-header--content> *',{
     y:30,
     opacity:0,    
     duration:0.8,
     stagger:0.5,
     scrollTrigger :{
        trigger:".collection-tabs",
        scroller :"body",
        start:"top 50%"
     }
});
 gsap.from('.featured-collection__inner product-card',{
     y:40,
     opacity:0,    
     duration:0.8,
     stagger:0.5,
     scrollTrigger :{
        trigger:".featured-collection__inner",
        scroller :"body",
        start:"top 60%"
     }
});
 gsap.from('.flickity-slider .carousel__slide',{
     y:40,
     opacity:0,    
     duration:0.8,
     stagger:0.5,
     scrollTrigger :{
        trigger:".flickity-slider",
        scroller :"body",
        start:"top 50%"
     }
});





})
